<template>
</template>

<script>
import { mapActions } from 'vuex'
/**
 * Componente que recibe los datos de autenticación luego de iniciar sesión
 *
 * @see {@link https://auth.omnitrack.com.co | Iniciar sesión}
 * @author Manuel Ochoa
 */
export default {
  name: 'callback',
  /**
   * Cuando se llama el componente, extrae los datos de autenticación desde los url query parameters
   * Y luego lo guarda en la store y cambia la ruta si es valido
   */
  methods: {
    ...mapActions(['setLogHistoryAuth'])
  },
  mounted() {
    this.$store.commit('auth/SET_ID_TOKEN', this.$route.query.idToken)
    let authResult = {
      accessToken: this.$route.query.accessToken,
      idToken: this.$route.query.idToken
    }
    this.$store.dispatch('auth/login', authResult).then(response => {
      response && this.$router.replace('/')
    })
    // Set log history for the login action
    this.setLogHistoryAuth('login')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Callback.vue